import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

export default class RestrictionSerializer extends ApplicationSerializer {
  normalize(
    typeClass: ModelSchema,
    hash: Record<string, unknown> & { override_ids?: unknown },
  ): object {
    if (hash.override_ids !== undefined) {
      hash['overrides'] = hash.override_ids;
      delete hash.override_ids;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }
}
